
<div class="cp-prize" :class="level" @click="choosePrize">
  <div class="bg" :class="level">
    <div class="prize" :class="`prize-${prize} ${star}`">
      <div v-if="drawed" class="drawed"></div>
    </div>
  </div>
  <div v-if="!drawed && checked" class="checked"></div>
  <div class="name" :class="level">
    {{name}}
  </div>
</div>
